const Flag = {
  CLEAN: 0,
  DIRTY: 1,
  properties: {
    0: {
      key: '0',
      value: 'Clean'
    },
    1: {
      key: '1',
      value: 'Dirty'
    }
  }
}

const AddedVia = {
  CHANGETYPE: 'changetype',
  MANUAL: 'manual',
  MOCTYPE: 'moctype',
  CHANGECATEGORY: 'changecategory',
  RESPONSE: 'response',
  QARELATIONSHIP: 'qarelationship',
  properties: {
    changetype: {
      key: 'changetype',
      value: 'ChangeType'
    },
    manual: {
      key: 'manual',
      value: 'Manual'
    },
    moctype: {
      key: 'moctype',
      value: 'MocType'
    },
    changecategory: {
      key: 'changecategory',
      value: 'ChangeCategory'
    },
    response: {
      key: 'response',
      value: 'Response'
    },
    qarelationship: {
      key: 'qarelationship',
      value: 'QARelationship'
    }
  }
}

export { Flag, AddedVia }
